import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './App.css';
import Home from './Home/Home';
import ScrollToTop from './Utilities/ScrollToTop';
import NavBar from './Utilities/NavBar/NavBar';
import Article from './Article/Article';
import About from './Pages/About';
import Footer from './Utilities/Footer/Footer';
import { Helmet } from 'react-helmet';
import BrokenLinkPage from './Utilities/BrokenLinkPage/BrokenLinkPage';
import Wargaming from './Pages/Wargaming';
import Businesses from './Pages/Businesses';
import ToolBox from './Pages/ToolBox';

function App() {
  return (
    <Router>
      <div className="App">
        <Helmet>
          <title>The Trehan</title>
          <meta charset="UTF-8" />
          <meta name='description' content='The Trehan offers strategic clarity, risk assessments, and data-backed reports on Asia&apos;s shifting landscape - designed for businesses, institutions, and media seeking reliable insights and actionable depth.' data-react-helmet="true"/>
          <meta name="theme-color" content="#000000" data-react-helmet="true"/>
          <meta name='keywords' content='Asia think tank, geopolitical insights, strategic foresight, economic risk analysis, business intelligence Asia, Indo-Pacific reports, war gaming, India market entry, Asia business strategy, political risk workshops' data-react-helmet="true"/>  
          <meta name="apple-mobile-web-app-capable" content="yes" data-react-helmet="true"/>
          <meta name="mobile-web-app-capable" content="yes" data-react-helmet="true"/>
          <meta name="apple-mobile-web-app-title" content='The Trehan' data-react-helmet="true"/>
          <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" data-react-helmet="true"/>
          <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" data-react-helmet="true"/>
          <link rel="manifest" href="/site.webmanifest" data-react-helmet="true"/>
          <link rel="mask-icon" href="/safari-pinned-tab.svg" color="#000000" data-react-helmet="true"/>
          <meta name="viewport" content="width=device-width, initial-scale=1.0" />
          <meta property="og:title" content="The Trehan | Strategic Reports, Risk Insights & Asia-Focused Analysis" />
          <meta property="og:description" content="The Trehan provides reliable, data-backed insights into Asia&apos;s economic and strategic shifts - built for decision-makers and media worldwide." />
          <meta property="og:image" content="https://firebasestorage.googleapis.com/v0/b/peshkar.appspot.com/o/ShareImage.png?alt=media&token=88c1b449-c029-4183-8de8-2633ba6c988e" />
          <meta property="og:url" content="https://www.thetrehan.com/" />
          <meta property="og:type" content="website" />
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content="The Trehan | Strategic Reports, Risk Insights & Asia-Focused Analysis" />
          <meta name="twitter:description" content="The Trehan provides reliable, data-backed insights into Asia&apos;s economic and strategic shifts - built for decision-makers and media worldwide." />
          <meta name="twitter:image" content="https://firebasestorage.googleapis.com/v0/b/peshkar.appspot.com/o/ShareImage.png?alt=media&token=88c1b449-c029-4183-8de8-2633ba6c988e" />
          <meta name="msapplication-TileColor" content="#000000"/>
        </Helmet>
        
        <NavBar/>
        
        {/* Main content area - wrapped for flex layout */}
        <main style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
          <ScrollToTop>
            <Routes>
              <Route path="/" exact Component={Home}/>
              <Route path="/about" exact element={<About/>}/>
              <Route path="/wargaming" exact element={<Wargaming/>}/>
              <Route path="/businesses" exact element={<Businesses/>}/>
              <Route path="/toolbox" exact element={<ToolBox/>}/>
              <Route path="/article/:id" exact Component={Article}/>
              <Route path="*" exact Component={BrokenLinkPage}/>
            </Routes>
          </ScrollToTop>
        </main>
        
        <Footer/>
      </div>
    </Router>
  );
}

export default App;